import * as React from "react";
import HeroBanner from "../../components/HeroBan";

//Slides
import image1 from "../../images/Image1.jpg";
import SlideShow from "../../components/slider";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../../components/layout";

const Residential = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential", idType: URI) {
          residentialPage {
            rsHeader
            rsItems {
              header
              content
              image {
                altText
                sourceUrl
              }
              link {
                target
                title
                url
              }
            }
            heroSlides {
              backgroundColor
              content
              header
              toggle
              link {
                target
                title
                url
              }
              image {
                altText
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialPage || {};

  return (
    <Layout pageContext={pageContext}>
      <SlideShow>
        {data?.heroSlides
          ?.filter((v) => v?.toggle)
          ?.map((v, i) => (
            <React.Fragment key={i}>
              <HeroBanner
                image={v?.image?.sourceUrl}
                color={v?.backgroundColor}
              >
                <h5>{v?.header}</h5>
                <p dangerouslySetInnerHTML={{ __html: v?.content }}></p>
                <a href={v?.link?.url} target={v?.link?.target}>
                  {v?.link?.title}
                </a>
              </HeroBanner>
            </React.Fragment>
          ))}
      </SlideShow>

      <div className="bg-black py-20">
        <h3 className="text-center text-5xl mb-10 container ">
          {data?.rsHeader}
        </h3>
        <div className="container flex flex-wrap mx-auto w-full md:w-4/5 lg:w-3/4 xl:w-11/12 2xl:w-4/5 text-white">
          {data?.rsItems.map((v, i) => (
            <div
              key={i}
              className="my-4 px-4 w-full md:w-1/2 lg:w-1/2 xl:w-1/4"
            >
              <div className="w-full">
                <div className="mx-auto h-32 flex max-w-110">
                  <img
                    className="w-full max-h-100"
                    src={v?.image?.sourceUrl}
                    alt={v?.image?.altText}
                  />
                </div>
                <h5 className="text-center text-3xl mt-2 mb-5">{v?.header}</h5>
                <p
                  className="h-36"
                  dangerouslySetInnerHTML={{ __html: v?.content }}
                ></p>

                <a href={v?.link?.url} target={v?.link?.target}>
                  <div className="bg-tan text-lg text-black uppercase font-anton text-center w-full py-2">
                    {v?.link?.title}
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Residential;
